// Module
var code = "<div class=\"{{class}}\" id=\"{{id}}\"> <script src=\"https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js\"></script> </div>";
// Exports
module.exports = code;